/**
 * Created by Victor Rojo on 10/10/18.
 */
import { Component, OnDestroy}     from '@angular/core';
import { Router, ActivatedRoute, Params }                   from '@angular/router';

import { interval ,  Unsubscribable as AnonymousSubscription }             from "rxjs";

import {Section, SectionMap} from "../section/Section";
import {Widget, WidgetTypes, WidgetStatus} from "../widget/Widget";
import {SectionService} from "../section/Section.service";
import {WidgetService} from "../widget/Widget.service";
import {IPlaceDataChangeService} from "../IPlaceDataChange.service";


@Component({
  templateUrl: './ErrorDashboard.component.html',
  styleUrls: ['./ErrorDashboard.component.css']
})
export class ErrorDashboardComponent implements OnDestroy{

  widgets: Widget[];
  widgetIds: string[];
  WidgetTypes: any;
  isLoading = false;
  widgetStatusChangeSubscription: any;
  private reloadWidgetsTimeout:any;

  private reloadWidgets:boolean = false;
  private reloadWidgetsInterval: AnonymousSubscription;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private sectionService: SectionService,
    private widgetService: WidgetService,
    private iPlaceDataChangeService: IPlaceDataChangeService
  ) {

    this.isLoading = true;
    this.WidgetTypes = WidgetTypes;
    this.widgetService.getStatusError().then((widgets:Widget[]) => {
      this.widgetIds = widgets.map( w => w.widgetId);
      this.widgets = widgets.sort( (w1,w2) => {
        if ( w1.positionY == w2.positionY) {
          return w1.positionX - w2.positionX;
        }
        return w1.positionY - w2.positionY;
      });
      this.isLoading = false;
    });

    this.widgetStatusChangeSubscription = this.iPlaceDataChangeService.widgetStatusChange$.subscribe( (widgetStatus:WidgetStatus) => {
      if ( widgetStatus.lines ) {
        this.addWidget(widgetStatus.widgetId);
      } else {
        this.removeWidget(widgetStatus.widgetId);
      }
    });

    this.reloadWidgetsInterval = interval(3000)
      .subscribe(() => {
        if ( this.reloadWidgets ) {
          this.widgetService.getStatusError().then((widgets:Widget[]) => {
            this.widgetIds = widgets.map( w => w.widgetId);
            this.widgets = widgets.sort( (w1,w2) => {
              if ( w1.positionY == w2.positionY) {
                return w1.positionX - w2.positionX;
              }
              return w1.positionY - w2.positionY;
            });
          });
          this.reloadWidgets = false;
        }
      });
  }

  private addWidget(widgetId: string) {
    this.reloadWidgets = true;
  }

  private removeWidget(widgetId:string){
    if ( this.widgetIds.indexOf(widgetId) != -1 ) {
      this.widgetIds = this.widgetIds.filter(id => id != widgetId);
      this.widgets = this.widgets.filter(widget => widget.widgetId != widgetId);
    }
  }

  isElementGroupWidget(widgetTypeId: number) {
    if ( widgetTypeId == WidgetTypes.LIGHTS_ON
      || widgetTypeId == WidgetTypes.NETWORK_DEVICES
      || widgetTypeId == WidgetTypes.SOCKETS_ON
      || widgetTypeId == WidgetTypes.STATUS_GROUP) {
      return true;
    }
    return false;
  }

  isDefaultWidget(widgetTypeId: number) {
    if ( widgetTypeId != WidgetTypes.GADGET_MAP
      && widgetTypeId != WidgetTypes.GADGET_GROUP
      && widgetTypeId != WidgetTypes.LIGHTS_ON
      && widgetTypeId != WidgetTypes.NETWORK_DEVICES
      && widgetTypeId != WidgetTypes.SOCKETS_ON
      && widgetTypeId != WidgetTypes.STATUS_GROUP
      && widgetTypeId != WidgetTypes.TANK
      && widgetTypeId != WidgetTypes.PUMP
      && widgetTypeId != WidgetTypes.PRICE_POLE) {
      return true;
    }
    return false;
  }

  getWidgetItemClass(widgetTypeId: number){
    switch (widgetTypeId){
      case WidgetTypes.GADGET_MAP:
        return "map";
      case WidgetTypes.WEATHER:
      case WidgetTypes.CLOCK:
        return "item-s";
      default:
        return "item";
    }
  }

  public ngOnDestroy(): void {
    if ( this.widgetStatusChangeSubscription ){
      this.widgetStatusChangeSubscription.unsubscribe();
    }
    if ( this.reloadWidgetsInterval ) {
      this.reloadWidgetsInterval.unsubscribe()
    }
  }
}
